import Vue from "vue"
import {
	setTimeout
} from "timers";
import moment from 'moment';



var bindDrag = (el) => {

	var handler = (event) => {
		event.preventDefault();
		return false;
	}

	el.addEventListener('dragenter', handler);
	el.addEventListener('dragover', handler);
	el.addEventListener('drop', handler);

}

Vue.directive('only-numeric', {
	bind: function (el, binding) {

		bindDrag(el);


		el.addEventListener('keydown', (e) => {

			let event = e || window.event;
			if (binding.arg && binding.arg === "decimal") {
				if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 37 && event.keyCode <= 40) ||
					(event.keyCode >= 96 && event.keyCode <= 105) ||
					event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 37 ||
					event.keyCode == 39 || event.keyCode == 46 || event.keyCode == 190 || event.keyCode == 110) {

				} else {
					event.preventDefault();
				}

				if (event.target.value.indexOf('.') !== -1 && (event.keyCode == 190 || event.keyCode == 110))
					event.preventDefault();

			} else {

				if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 37 && event.keyCode <= 40) ||
					(event.keyCode >= 96 && event.keyCode <= 105) ||
					event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 46) {

				} else {
					event.preventDefault();
				}
			}
		})

	}
})

Vue.directive('only-numeric-rate', {
	bind: function (el, binding) {

		bindDrag(el);


		el.addEventListener('keypress', (e) => {

			let event = e || window.event;
			if (binding.arg && binding.arg === "decimal") {
				if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 37 && event.keyCode <= 40) ||
					event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 37 ||
					event.keyCode == 39 || event.keyCode == 46 || event.keyCode == 190 || event.keyCode == 110) {

				} else {
					event.preventDefault();
				}

				if (event.target.value.indexOf('.') !== -1 && (event.keyCode == 190 || event.keyCode == 110))
					event.preventDefault();

				//restrict to two decimal
				var caratPos = getSelectionStart(el);
				var dotPos = event.target.value.indexOf(".");
				if (caratPos > dotPos && dotPos > -1 && (event.target.value.split('.')[1].length > 1)) {
					event.preventDefault();
				}

			}
		})

	}
})


Vue.directive('only-text', {
	bind: function (el, binding) {

		el.addEventListener('keypress', (e) => {

			let event = e || window.event;
			var keyCode = e.which;

			/* 
			48-57 - (0-9)Numbers
			65-90 - (A-Z)
			97-122 - (a-z)
			8 - (backspace)
			32 - (space)
			*/
			// Not allow special 
			if (!(
					(keyCode >= 65 && keyCode <= 90) ||
					(keyCode >= 97 && keyCode <= 122)) && keyCode != 8 && keyCode != 32) {
				e.preventDefault();
			}

		})

	}
})


Vue.directive('only-text-number', {
	bind: function (el, binding) {



		el.addEventListener('keypress', (e) => {

			let event = e || window.event;
			var keyCode = e.which;

			/* 
			48-57 - (0-9)Numbers
			65-90 - (A-Z)
			97-122 - (a-z)
			8 - (backspace)
			32 - (space)
			*/
			// Not allow special 
			if (!((keyCode >= 48 && keyCode <= 57) ||
					(keyCode >= 65 && keyCode <= 90) ||
					(keyCode >= 97 && keyCode <= 122)) &&
				keyCode != 8 && keyCode != 32) {
				e.preventDefault();
			}

		})

	}
})

Vue.directive("only-uppercase", {
	twoWay: true,
	// TODO: unbind
	unbind: () => {},
	bind: function (el, binding, vnode) {
		const findVModelName = vnode => {
			try {
				// https://forum.vuejs.org/t/solved-how-can-you-update-the-v-model-from-a-custom-directive-in-vue-2/2275
				return vnode.data.directives.find(o => {
					return o.name === "model";
				}).expression;
			} catch (error) {
				error.message = `Unable to find v-model directive at ${
			vnode.tag
		  } tag. Please specify the expression: v-uppercase='obj.prop'`;
				throw error;
			}
		};

		const funcByName = (functionName, context, value) => {
			// https://stackoverflow.com/a/359910/8801075
			var namespaces = functionName.split(".");
			var func = namespaces.pop();
			for (var i = 0; i < namespaces.length; i++)
				context = context[namespaces[i]];
			return (context[func] = value);
		};

		var expression = binding.expression ?
			binding.expression :
			findVModelName(vnode);
		vnode.context.$watch(expression, {
			//deep: true, // ?
			immediate: true,
			handler(newVal) {
				if (newVal) {
					return funcByName(
						expression,
						vnode.context,
						newVal.toString().toLocaleUpperCase()
					);
				}
			}
		});
	}
});




Vue.directive('mobile-normal', {
	bind: function (el, binding) {

		el.addEventListener('keypress', (e) => {

			let event = e || window.event;
			var keyCode = e.which;

			/* 
			48-57 - (0-9)Numbers
			65-90 - (A-Z)
			97-122 - (a-z)
			8 - (backspace)
			32 - (space)
			*/
			// Not allow special 
			if (!(keyCode == 43 || (keyCode >= 48 && keyCode <= 57)) &&
				keyCode != 8) {
				e.preventDefault();
			}

		})

	}
})


Vue.directive('drag-disable', {
	bind: function (el, binding) {
		bindDrag(el);
	}

})

var getSelectionStart = (o) => {
	if (o.createTextRange) {
		var r = document.selection.createRange().duplicate()
		r.moveEnd('character', o.value.length)
		if (r.text == '') return o.value.length
		return o.value.lastIndexOf(r.text)
	} else return o.selectionStart
}

Vue.filter('two_digits', function (value) {
	if (value.toString().length <= 1) {
		return "0" + value.toString();
	}
	return value.toString();
});

Vue.filter('formatDate', function (value) {
	if (value) {
		return moment(String(value)).format('DD/MM/YYYY')
	}
});
